import { css } from 'lit';

export const labelMaterial = css`
  .proposal-form__label {
    display: none;
    position: absolute;
    top: -0.8rem;
    left: 1rem;
    padding: 0 0.5rem;
    background-color: #fff;
    margin-bottom: 5px;
    z-index: 20;
    font-size: 1.2rem;
    line-height: 1.6rem;
    text-transform: lowercase;
    color: #9b9b9b;
  }
`